import * as React from 'react'
import styled from 'styled-components'
import memoize from '../memoize'
import Button from './Button'
import { Spacer } from './core'

interface Option {
  key: string
  name: string
}

export default class Toggle extends React.PureComponent<{
  options: (string | Option)[]
  multiselect?: boolean
  value?: string
  values?: string[]
  onSelect: (vals: string[]) => void
}> {
  private handlers = {}

  render() {
    const { options, multiselect } = this.props
    const values = this.props.values || [this.props.value]

    const keys = options.map(o => (o as Partial<Option>).key || (o as string))
    const invalidIx = values.findIndex(v => !v || !keys.includes(v))
    if (invalidIx >= 0) {
      throw new Error('Invalid value at index ' + invalidIx + ': ' + values[invalidIx])
    }

    const elems = []
    for (let i = 0; i < options.length; i++) {
      const o = options[i]
      const key = (o as Partial<Option>).key || (o as string)
      const name = (o as Partial<Option>).name || (o as string)
      const isSel = values.includes(key)
      const isDisabled = !multiselect && isSel
      const onClk = isDisabled ? null : memoize(this.handlers, key, () => () => this.onClick(key))
      elems.push(
        <Button size="small" filled={isSel} key={'btn-' + key} onClick={isDisabled ? null : onClk}>
          {name}
        </Button>
      )
      if (i < options.length - 1) {
        elems.push(<Spacer width={8} key={'space-' + key} />)
      }
    }

    return <ToggleWrap>{elems}</ToggleWrap>
  }

  private onClick(key: string) {
    const { multiselect, onSelect } = this.props
    if (multiselect) {
      const values = this.props.values!.slice()
      const ix = values.indexOf(key)
      if (ix < 0) {
        values.push(key)
      } else {
        values.splice(ix, 1)
      }
      onSelect(values)
    } else {
      onSelect([key])
    }
  }
}

const ToggleWrap = styled.span`
  line-height: 32px;
`
